<nz-drawer [nzVisible]="visible" (nzOnClose)="close.emit()" nzPlacement="right" [nzWidth]="420" [nzTitle]="drawerTitle" [nzFooter]="drawerFooter">
  <ng-template #drawerTitle>
    <div class="header">
      <div class="title">{{ title }}</div>
      <div class="right">
        <nz-tag [nzColor]="statusTag.color">{{ statusTag.text }}</nz-tag>
        @if (uiState === 'IMPORT_FAILED') {
        <button nz-button nzDanger nzType="default" type="button" (click)="onRetry()">
          <i nz-icon nzType="reload"></i>
          Reintentar
        </button>
        }
      </div>
    </div>
  </ng-template>

  <ng-container *nzDrawerContent>
    <div class="section-title">Información del catálogo</div>
    <nz-card class="info-card">
      <div class="kv">
        <div class="k">ID:</div>
        <div class="v">{{ catalogo?.id || catalogo?.catalogo?.id || '—' }}</div>
      </div>
      <div class="kv">
        <div class="k">Nombre:</div>
        <div class="v">{{ catalogo?.nombre || catalogo?.descripcion || '—' }}</div>
      </div>
      <div class="kv">
        <div class="k">Estado:</div>
        <div class="v">{{ statusTag.text }}</div>
      </div>
      <div class="kv">
        <div class="k">Fecha:</div>
        <div class="v">
          {{ mainDate | date: 'dd/MM/yyyy, HH:mm':'UTC':'es-ES' }}
        </div>
      </div>
    </nz-card>

    <div class="section-title">Historial de acciones</div>
    <nz-timeline>
      @for (h of history; track trackByHistory($index, h)) {
      <nz-timeline-item [nzColor]="h.type === 'error' ? 'red' : h.type === 'published' ? 'green' : 'blue'">
        <div class="tl-row">
          <div class="tl-label">{{ h.label }}</div>
          <div class="tl-date">{{ h.date | date: 'dd/MM/yyyy, HH:mm' }}</div>
        </div>
        @if (h.description) {
        <div class="tl-desc">{{ h.description }}</div>
        }
      </nz-timeline-item>
      }
    </nz-timeline>
  </ng-container>

  <ng-template #drawerFooter>
    <div class="footer">
      <button type="button" nz-button (click)="close.emit()">
        <i nz-icon nzType="close"></i>
        Cerrar
      </button>
    </div>
  </ng-template>
</nz-drawer>
